import { db } from "../../firebase";
import { doc, setDoc } from "firebase/firestore";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";
import HelperForMetaData from "../../helpers/HelperForMetaData";

const AddProperty = async (propertyId, e) => {
  try {
    const PropertiesCollection = await doc(db, "properties", propertyId);
    await setDoc(PropertiesCollection, {
      ...e,
      bid: getLocalStorageItem("bid"),
      sharedAt: null,
      propertyStatus: "available",
      ...HelperForMetaData({}),
    });
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default AddProperty;
